import { Icon } from '@chakra-ui/react';
import { FaUsers } from 'react-icons/fa';
import { FiUsers } from "react-icons/fi";
import { MdDashboard, MdDiscount, MdGroups, MdHomeRepairService, MdSpaceDashboard } from 'react-icons/md';
import { SiGoogleads } from "react-icons/si";
import { PiListDashesFill, PiLockSimpleOpenFill } from "react-icons/pi";
import { TiLocation } from 'react-icons/ti';
import { IoIosNotifications } from 'react-icons/io';
import { IoSettings } from 'react-icons/io5';
import { BiSolidCategory } from 'react-icons/bi';
import { CgImport } from "react-icons/cg";

// Page Imports
import Audit from 'pages/audit/Audit';
import Dashboard from 'pages/dashboard/Dashboard';
import DiscountsOverview from 'pages/discount/DiscountsOverview';
import KisiLocks from 'pages/kisi/KisiLocks';
import LocationsOverview from 'pages/location/LocationsOverview';
import Permission from 'pages/permission/Permission';
import ServicesOverview from 'pages/service/ServiceOverview';
import Members from 'pages/users/Members';
import UsersOverview from 'pages/users/UsersOverview';
import NewUser from 'pages/users/NewUser';
import NewMember from 'pages/users/NewMember';
import NewLocation from 'pages/location/NewLocation';
import NewService from 'pages/service/NewService';
import NewDiscount from 'pages/discount/NewDiscount';
import EditProfile from 'pages/profile/EditProfile';
import DiscountClaim from 'pages/discount/DiscountClaim';
import NotificationsOverview from 'pages/notification/NotificationOverview';
import NewNotification from 'pages/notification/NewNotification';
import Setting from 'pages/setting/Setting';
import AdsOverview from 'pages/Ads/AdsOverview';
import NewAds from 'pages/Ads/NewAds';
import ServiceCategoriesOverview from 'pages/service/ServiceCategoriesOverView';
import NewServiceCategory from 'pages/service/NewServiceCategory';
import DiscountCategoriesOverview from 'pages/discount/DiscountCategoriesOverView';
import NewDiscountCategory from 'pages/discount/NewDiscountCategory';
import NewGroups from 'pages/groups/NewGroups';
import GroupMemebersOverview from 'pages/groups/GroupMembersOverview';
import ImportGroupMembers from 'pages/groups/ImportGroupMembers';

const routes = [
  // Dashboard Section
  {
    name: 'Dashboard',
    value: 'dashboard',
    method: 'read',
    layout: '/admin',
    path: '/dashboard/overview',
    icon: <Icon as={MdSpaceDashboard} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: Dashboard,
  },

  // Users Section
  {
    name: 'Staff',
    value: 'staff',
    method: 'read',
    icon: <Icon as={FaUsers} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    path: '/staff',
    exact: false,
    show: true,
    collapse: false,
    component: UsersOverview,
  },
  {
    name: 'New Staff',
    value: 'staff',
    method: 'create',
    icon: <Icon as={FaUsers} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    path: '/staff/create',
    exact: false,
    show: false,
    collapse: false,
    component: NewUser,
  },
  {
    name: 'Edit Staff',
    value: 'staff',
    method: 'update',
    icon: <Icon as={FaUsers} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    path: '/staff/edit/:id',
    exact: false,
    show: false,
    collapse: false,
    component: NewUser,
  },

  // Profile Section
  {
    name: 'Profile',
    value: 'profile',
    method: 'read',
    icon: <Icon as={FaUsers} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    path: '/profile/edit',
    exact: false,
    show: false,
    collapse: false,
    component: EditProfile,
  },

  //Member Section
  {
    name: 'Members',
    value: 'members',
    method: 'read',
    layout: '/admin',
    icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
    path: '/members',
    exact: false,
    show: true,
    component: Members,
  },
  {
    name: 'New Member',
    value: 'members',
    method: 'create',
    layout: '/admin',
    icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
    path: '/members/create',
    exact: false,
    show: false,
    component: NewMember,
  },
  {
    name: 'Edit Member',
    value: 'members',
    method: 'update',
    layout: '/admin',
    icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
    path: '/members/edit/:id',
    exact: false,
    show: false,
    component: NewMember
  },

  //Member Groups
  {
    name: 'Member Groups',
    value: 'members',
    method: 'read',
    layout: '/admin',
    path: '/member/groups',
    icon: <Icon as={MdGroups} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: GroupMemebersOverview,
  },
  {
    name: 'New Member Groups',
    value: 'members',
    method: 'create',
    layout: '/admin',
    path: '/member/groups/create',
    icon: <Icon as={MdGroups} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewGroups,
  },
  {
    name: 'Edit Member Groups',
    value: 'members',
    method: 'update',
    layout: '/admin',
    path: '/member/groups/edit/:id',
    icon: <Icon as={SiGoogleads} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewGroups,
  },

  //Import group members
  {
    name: 'Import Group Members',
    value: 'members',
    method: 'read',
    layout: '/admin',
    path: '/groups/member/import',
    icon: <Icon as={CgImport} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: ImportGroupMembers,
  },

  // Locations Section
  {
    name: 'Locations',
    value: 'locations',
    method: 'read',
    layout: '/admin',
    path: '/locations',
    icon: <Icon as={TiLocation} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: LocationsOverview,
  },
  {
    name: 'Edit Location',
    value: 'locations',
    method: 'update',
    layout: '/admin',
    path: '/locations/edit/:id',
    icon: <Icon as={TiLocation} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewLocation,
  },

  // Services Section
  {
    name: 'Services',
    value: 'services',
    method: 'read',
    layout: '/admin',
    icon: <Icon as={MdHomeRepairService} width="20px" height="20px" color="inherit" />,
    path: '/services',
    exact: false,
    show: true,
    component: ServicesOverview,
  },
  {
    name: 'New Service',
    value: 'services',
    layout: '/admin',
    method: 'create',
    icon: <Icon as={MdHomeRepairService} width="20px" height="20px" color="inherit" />,
    path: '/services/create',
    exact: false,
    show: false,
    component: NewService,
  },
  {
    name: 'Edit Service',
    value: 'services',
    method: 'update',
    layout: '/admin',
    icon: <Icon as={MdHomeRepairService} width="20px" height="20px" color="inherit" />,
    path: '/services/edit/:id',
    exact: false,
    show: false,
    component: NewService,
  },

  // Discount Section
  {
    name: 'Discounts',
    value: 'discounts',
    method: 'read',
    layout: '/admin',
    path: '/discounts',
    icon: <Icon as={MdDiscount} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: DiscountsOverview,
  },
  {
    name: 'New Discount',
    value: 'discounts',
    method: 'create',
    layout: '/admin',
    path: '/discounts/create',
    icon: <Icon as={MdDiscount} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewDiscount,
  },
  {
    name: 'Discount Claims',
    value: 'discounts',
    method: 'read',
    layout: '/admin',
    path: '/discounts/claim/:id',
    icon: <Icon as={MdDiscount} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: DiscountClaim,
  },
  {
    name: 'Edit Discount',
    value: 'discounts',
    method: 'update',
    layout: '/admin',
    path: '/discounts/edit/:id',
    icon: <Icon as={MdDiscount} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewDiscount,
  },

  // Kisi Section
  {
    name: 'Locks',
    value: 'locks',
    method: 'read',
    layout: '/admin',
    path: '/locks',
    icon: <Icon as={PiListDashesFill} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: KisiLocks,
  },

  // Notification Section
  {
    name: 'Notifications',
    value: 'notifications',
    method: 'read',
    layout: '/admin',
    path: '/notifications',
    icon: <Icon as={IoIosNotifications} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: NotificationsOverview,
  },
  {
    name: 'New Notification',
    value: 'notifications',
    method: 'create',
    layout: '/admin',
    path: '/notifications/create',
    icon: <Icon as={IoIosNotifications} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewNotification,
  },
  {
    name: 'Edit Notification',
    value: 'notifications',
    method: 'update',
    layout: '/admin',
    path: '/notifications/edit/:id',
    icon: <Icon as={IoIosNotifications} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewNotification,
  },

  // Service Category Section
  {
    name: 'Service Categories',
    value: 'services',
    method: 'read',
    layout: '/admin',
    path: '/service/category',
    icon: <Icon as={BiSolidCategory} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: ServiceCategoriesOverview,
  },
  {
    name: 'New Service Category',
    value: 'services',
    method: 'create',
    layout: '/admin',
    path: '/service/category/create',
    icon: <Icon as={BiSolidCategory} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewServiceCategory,
  },
  {
    name: 'Edit Service Category',
    value: 'services',
    method: 'update',
    layout: '/admin',
    path: '/service/category/edit/:id',
    icon: <Icon as={IoIosNotifications} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewServiceCategory,
  },

  // Discount Category Section
  {
    name: 'Discount Categories',
    value: 'discounts',
    method: 'read',
    layout: '/admin',
    path: '/discount/category',
    icon: <Icon as={BiSolidCategory} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: DiscountCategoriesOverview,
  },
  {
    name: 'New Discount Category',
    value: 'discounts',
    method: 'create',
    layout: '/admin',
    path: '/discount/category/create',
    icon: <Icon as={BiSolidCategory} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewDiscountCategory,
  },
  {
    name: 'Edit Discount Category',
    value: 'discounts',
    method: 'update',
    layout: '/admin',
    path: '/discount/category/edit/:id',
    icon: <Icon as={IoIosNotifications} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewDiscountCategory,
  },

  // Ads Section
  {
    name: 'Ads',
    value: 'ads',
    method: 'read',
    layout: '/admin',
    path: '/ads',
    icon: <Icon as={SiGoogleads} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: AdsOverview,
  },
  {
    name: 'New Ads',
    value: 'ads',
    method: 'create',
    layout: '/admin',
    path: '/ads/create',
    icon: <Icon as={SiGoogleads} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewAds,
  },
  {
    name: 'Edit Ads',
    value: 'ads',
    method: 'update',
    layout: '/admin',
    path: '/ads/edit/:id',
    icon: <Icon as={SiGoogleads} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: false,
    component: NewAds,
  },

  // Permission Section
  {
    name: 'Permissions',
    value: 'permissions',
    method: 'read',
    layout: '/admin',
    path: '/permissions',
    icon: <Icon as={PiLockSimpleOpenFill} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: Permission,
  },

  // Audits Section
  {
    name: 'Users Audit',
    value: 'audits',
    method: 'read',
    layout: '/admin',
    path: '/audits',
    icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: Audit,
  },

  // Setting Section
  {
    name: 'Setting',
    value: 'setting',
    method: 'update',
    layout: '/admin',
    path: '/setting',
    icon: <Icon as={IoSettings} width="20px" height="20px" color="inherit" />,
    exact: false,
    show: true,
    component: Setting,
  },
];

export default routes;
